import { useState, useEffect } from 'react';

const DEFAULT_TMR = {
  value: 4025.75,
  deltaPercent: 0.68,
  updatedAt: '11:45 AM',
};

function useTmr() {
  const [tmrData, setTmrData] = useState(DEFAULT_TMR);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTmrData = async () => {
      try {
        const url = "https://www.datos.gov.co/resource/mcec-87by.json?$select=vigenciadesde,vigenciahasta,valor&$order=vigenciadesde%20DESC&$limit=1";
        const response = await fetch(url);
        const data = await response.json();

        if (data && data[0]) {
          const tmrValue = parseFloat(data[0].valor);
          const now = new Date();
          const hours = now.getHours();
          const minutes = now.getMinutes();
          const ampm = hours >= 12 ? 'PM' : 'AM';
          const displayHours = hours % 12 || 12;
          const displayMinutes = minutes.toString().padStart(2, '0');

          setTmrData({
            value: tmrValue,
            deltaPercent: 0, // No tenemos dato histórico para calcular el delta
            updatedAt: `${displayHours}:${displayMinutes} ${ampm}`,
          });
        }
      } catch (error) {
        console.error('Error fetching TMR data:', error);
        // Mantener valores por defecto en caso de error
      } finally {
        setLoading(false);
      }
    };

    fetchTmrData();
  }, []);

  return { ...tmrData, loading };
}

export default useTmr;
